<div class="step-amount">

  <!-- <div *ngIf="!showAmountForm">
    <h3 class="heading">{{ 'PARTNER.WIZARD.SCAN_LOYALTY.HEADING' | translate }}</h3>
    <div class="step-scanner">
      <div class="zxing-scanner">
        <zxing-scanner [formats]="['QR_CODE', 'EAN_13', 'CODE_128', 'DATA_MATRIX']"
          (scanSuccess)="scanSuccessHandler($event)" (scanError)="scanErrorHandler($event)">
        </zxing-scanner>
      </div>
    </div>
  </div>
  <button class="btn btn-primary" type="button" (click)="onShowIdentifierFormChange()">
    <span *ngIf="!showAmountForm; else back_to_scanner">
      {{ 'PARTNER.WIZARD.SCAN_LOYALTY.ALT_PROMPT' | translate }}
    </span>
    <ng-template #back_to_scanner>
      <span>{{ 'PARTNER.WIZARD.BACK_TO_SCANNER' | translate }}</span>
    </ng-template>
  </button> -->

  <!--begin::Form(Wizard Step 3)-->
  <form [formGroup]="stepperForm" class="mt-3">

    <h5 class="heading">{{ 'PARTNER.WIZARD.SUB_AMOUNT_FORM.HEADING' | translate }}</h5>

    <!--begin::Form Group "Transaction's Amount"-->
    <div class="form-group">
      <div class="input-group amount-input">
        <span class="input-group-text">€</span>
        <input type="number" class="form-control" name="amount" formControlName="amount" placeholder="0">
      </div>
      <span *ngIf="isControlHasError('amount','required')" class="error text-danger">
        {{ 'FORM.VALIDATION.REQUIRED_FIELD' | translate }}
      </span>
      <span *ngIf="isControlHasError('amount','min')" class="error text-danger">
        {{ 'FORM.VALIDATION.MIN_VALUE_FIELD' | translate }}: {{ '1' | currency: 'EUR'}}
      </span>
      <span class="form-text text-muted">
        {{ 'PARTNER.WIZARD.SUB_AMOUNT_FORM.HINT' | translate }}
      </span>
    </div>
    <!--end::Form Group "Transaction's Amount"-->

  </form>
  <!--end::Form(Wizard Step 3)-->

  <!--begin::Wizard Buttons-->
  <button mat-raised-button class="mr-2" (click)="onPreviousStep()">
    {{ 'PARTNER.WIZARD.PREVIOUS_STEP' | translate }}
  </button>
  <button class="btn btn-primary" (click)="onNextStep()">
    {{ 'PARTNER.WIZARD.NEXT_STEP' | translate }}
  </button>
  <!--end::Wizard Buttons-->

</div>